import { render, staticRenderFns } from "./NewUserLoginStat.vue?vue&type=template&id=5245c39a&scoped=true&"
import script from "./NewUserLoginStat.vue?vue&type=script&lang=js&"
export * from "./NewUserLoginStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5245c39a",
  null
  
)

export default component.exports